import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {},

  contentWrapper: {
    paddingTop: 20,
    paddingHorizontal: 40,
  },

  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 900,
    textAlign: 'left',
  },

  gridWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    rowGap: 15,
    columnGap: 20,

    width: '100%',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: 10,

    backgroundColor: '#ffffff',
    border: '2px solid black',
    borderRadius: 8,

    height: 120,

    padding: 10,
    marginBottom: 15,
  },
  itemTitle: {
    fontFamily: 'Lato',
    fontWeight: 900,
    fontSize: 9,
    textAlign: 'left',
  },
  itemText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
    textAlign: 'left',
  },

  columnsWrapper: {
    flexDirection: 'row',
    width: '100%',
    marginTop: 40,
  },
  column: {
    flex: 1,
    flexDirection: 'column',
  },
});
